import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { ManufacturingApiConfiguration } from './configuration';
import { HttpClient } from '@angular/common/http';


@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class ManufacturingApiModule {
    public static forRoot(configurationFactory: () => ManufacturingApiConfiguration): ModuleWithProviders<ManufacturingApiModule> {
        return {
            ngModule: ManufacturingApiModule,
            providers: [ { provide: ManufacturingApiConfiguration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: ManufacturingApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('ManufacturingApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
